import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { ruleSourceDisplayLabels } from "@components/pageHeader/filters/lib";
import { formatFilterLabelText } from "./formatFilterLabel";

interface Props {
    filters: Pick<FiltersTypes, "ruleSources">;
}

export const RulesSourceFilterLabel: React.FC<Props> = ({
    filters: { ruleSources },
}) => (
    <>
        {formatFilterLabelText(
            (ruleSources ?? []).map(
                (source) => ruleSourceDisplayLabels[source],
            ),
            "Sources",
        ) ?? "All"}
    </>
);
